var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78781 0C9.2428 0 11.2182 1.93183 11.2182 4.3168V5.54348C12.5961 5.97357 13.6 7.22091 13.6 8.71072V12.6602C13.6 14.5046 12.0709 16 10.1858 16H3.41504C1.52909 16 0 14.5046 0 12.6602V8.71072C0 7.22091 1.00476 5.97357 2.38183 5.54348V4.3168C2.38996 1.93183 4.36533 0 6.78781 0ZM6.79594 9.10742C6.40574 9.10742 6.0887 9.41747 6.0887 9.79907V11.5639C6.0887 11.9535 6.40574 12.2635 6.79594 12.2635C7.19426 12.2635 7.5113 11.9535 7.5113 11.5639V9.79907C7.5113 9.41747 7.19426 9.10742 6.79594 9.10742ZM6.80406 1.39124C5.15385 1.39124 3.81255 2.69502 3.80442 4.3009V5.37096H9.79558V4.3168C9.79558 2.70297 8.45427 1.39124 6.80406 1.39124Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.afe3617597cae951780407c6623007a9.svg";
export { ForwardRef as ReactComponent };